import { memo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import "./DiscountedAccommodationTag.scss";
import AmountContainer from "app/pages/.shared/AmountContainer";
import { TagFilledIcon } from "app/icons/finance";

const DiscountedAccommodationTag = ({ value }) => {
	return (
		<div className="discounted-accommodation-tag" data-testid="discounted-accommodation-tag">
			<TagFilledIcon />
			<div className="discounted-accommodation-tag__label">
				<Typography variant={TYPOGRAPHY_VARIANTS.SMALL} isBold component="span">
					<FormattedMessage
						id="product.discounted.accommodation.tag"
						values={{ amount: <AmountContainer amount={value} /> }}
					/>
				</Typography>
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XSMALL}
					isBold
					component="span"
					className="discounted-accommodation-tag__suffix"
				>
					<FormattedMessage id="general.amount.per.person.suffix.label.short" />
				</Typography>
			</div>
		</div>
	);
};

DiscountedAccommodationTag.propTypes = {
	value: PropTypes.number.isRequired,
};

export default memo(DiscountedAccommodationTag);
